<template>
  <div class="no-auth-container">
    <h1 class="no-auth-title">
        <Icon type="md-close" color="#ff6b6b"/>{{ getTranslation("c019") }}
      </h1>

    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NoAuth',
  computed: {
    ...mapGetters(['getTranslation'])
  },
   components: {
    
  },
  methods: {
   
  }
}
</script>

<style scoped>
.no-auth-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vh;
  
  padding: 20px;
}

.no-auth-content {
  text-align: center;
  background: white;
  padding: 60px 40px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  animation: fadeInUp 0.6s ease-out;
}

</style>